import { Label } from "@components/atoms";
import Input from "@components/atoms/Input/Input";
import type { UserField } from "types/UserZendesk";
import { MultiSelectField } from "@components/organism";
interface FieldRendererProps {
    field: UserField;
    value: string | boolean | number | string[] | Date | RegExp | null;
    maxLength?: number;
    onChange: (value: string | boolean | number | string[] | Date | RegExp) => void;
    className?: string;
    onCopy?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
}

export const FieldRenderer = ({ field, value, onChange, maxLength, className, onCopy }: FieldRendererProps) => {
    const handleChange = (newValue: string | boolean | number | string[] | Date | RegExp) => {
        switch (field.type) {
            case 'integer':
                onChange(Number(newValue));
                break;
            case 'checkbox':
                onChange(Boolean(newValue));
                break;
            default:
                onChange(newValue);
        }
    };

    switch (field.type) {
        case 'text':
        case 'textarea':
            return (
                <div className="mb-4">
                    <Label title={field.title} />
                    <Input
                        type="text"
                        value={value as string}
                        onChange={(e) => handleChange(e.target.value)}
                        maxLength={maxLength}
                        className={className}
                        onCopy={onCopy}
                    />
                </div>
            );
        case 'regexp': {
            const isCNPJ = field.title?.startsWith('CNPJ');

            const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                let input = e.target.value;

                if (isCNPJ) {
                    input = input.replace(/\D/g, '').slice(0, 14);
                }

                handleChange(input);
            };
            return (
                <div className="mb-4">
                    <Label title={field.title} />
                    <Input
                        type="text"
                        value={value as string}
                        onChange={handleInputChange}
                        className={className}
                        onCopy={onCopy}
                    />
                </div>
            );
        }

        case 'dropdown':
            return (
                <div className="mb-4">
                    <Label title={field.title} />
                    <select
                        value={value as string}
                        onChange={(e) => handleChange(e.target.value)}
                        className="w-full px-3 py-2 border rounded border-gray-300"
                    >
                        <option value="">Selecione...</option>
                        {field.custom_field_options?.map(option => (
                            <option key={option.id} value={option.value}>
                                {option.name}
                            </option>
                        ))}
                    </select>
                </div>
            );

        case 'checkbox':
            return (
                <div className="mb-4 flex items-center">
                    <input
                        type="checkbox"
                        checked={value as boolean}
                        onChange={(e) => handleChange(e.target.checked)}
                        className="mr-2"
                    />
                    <Label title={field.title} />
                </div>
            );

        case 'multiselect':
            return (
                <MultiSelectField
                    field={field}
                    value={value as string[]}
                    onChange={(val) => handleChange(val)}
                />
            );

        case 'integer':
            return (
                <div className="mb-4">
                    <Label title={field.title} />
                    <input
                        type="number"
                        value={value as number}
                        onChange={(e) => handleChange(e.target.value)}
                        className={`w-full px-3 py-2 border rounded border-gray-300 ${className}`}
                        onCopy={onCopy}
                    />
                </div>
            );

        default:
            return (
                <div className="mb-4">
                    <Label title={field.title} />
                    <Input
                        type="text"
                        value={value as string}
                        onChange={(e) => handleChange(e.target.value)}
                        className={className}
                    />
                </div>
            );
    }
};